export interface Question {
  id: number;
  icon: string;
  question: string;
  options: {
    text: string;
    value: string;
  }[];
}

export interface BreedInfo {
  name: string;
  image: string;
  description: string;
}

export interface Result {
  title: string;
  description: string;
  breeds: BreedInfo[];
  advice: string;
}

export const questions: Question[] = [
  {
    id: 1,
    icon: 'ri-home-4-line',
    question: '¿Dónde vives actualmente?',
    options: [
      { text: 'Piso pequeño en ciudad', value: 'A' },
      { text: 'Piso amplio / ático', value: 'B' },
      { text: 'Casa con patio o jardín', value: 'C' },
      { text: 'Casa en zona rural o pueblo', value: 'D' }
    ]
  },
  {
    id: 2,
    icon: 'ri-time-line',
    question: '¿Cuánto tiempo REAL puedes dedicarle al perro al día?',
    options: [
      { text: '30–60 minutos', value: 'A' },
      { text: '1–2 horas', value: 'B' },
      { text: '2–3 horas', value: 'C' },
      { text: 'Gran parte del día', value: 'D' }
    ]
  },
  {
    id: 3,
    icon: 'ri-run-line',
    question: 'Tu nivel de actividad es…',
    options: [
      { text: 'Bajo (paseos tranquilos)', value: 'A' },
      { text: 'Moderado (caminar + algo de ejercicio)', value: 'B' },
      { text: 'Alto (running, senderismo)', value: 'C' },
      { text: 'Muy alto (vida outdoor diaria)', value: 'D' }
    ]
  },
  {
    id: 4,
    icon: 'ri-briefcase-line',
    question: 'Entre semana tú…',
    options: [
      { text: 'Paso muchas horas fuera', value: 'A' },
      { text: 'Tengo horario estable pero salgo varias horas', value: 'B' },
      { text: 'Teletrabajo o estoy bastante en casa', value: 'C' },
      { text: 'Siempre hay alguien en casa', value: 'D' }
    ]
  },
  {
    id: 5,
    icon: 'ri-brain-line',
    question: '¿Qué tan importante es entrenar/educar?',
    options: [
      { text: 'Solo lo básico', value: 'A' },
      { text: 'Básico + normas de casa', value: 'B' },
      { text: 'Me gusta entrenar y aprender', value: 'C' },
      { text: 'Quiero retos mentales y trabajo', value: 'D' }
    ]
  },
  {
    id: 6,
    icon: 'ri-group-line',
    question: 'En casa normalmente hay…',
    options: [
      { text: 'Vivo solo/a o en pareja', value: 'A' },
      { text: 'Adultos principalmente', value: 'B' },
      { text: 'Niños ocasionalmente', value: 'C' },
      { text: 'Niños pequeños / familia numerosa', value: 'D' }
    ]
  },
  {
    id: 7,
    icon: 'ri-volume-up-line',
    question: 'Sobre ladridos y vecinos…',
    options: [
      { text: 'Cero margen (vecinos muy cerca)', value: 'A' },
      { text: 'Un poco es normal, sin exceso', value: 'B' },
      { text: 'No me preocupa mucho', value: 'C' },
      { text: 'Vivo aislado, no importa', value: 'D' }
    ]
  },
  {
    id: 8,
    icon: 'ri-scissors-cut-line',
    question: 'Sobre el pelo…',
    options: [
      { text: 'Prefiero mínimo mantenimiento', value: 'A' },
      { text: 'No me importa aspirar seguido', value: 'B' },
      { text: 'Me gusta cepillarlo', value: 'C' },
      { text: 'Me da igual', value: 'D' }
    ]
  },
  {
    id: 9,
    icon: 'ri-ruler-line',
    question: '¿Qué tamaño te atrae más?',
    options: [
      { text: 'Pequeño', value: 'A' },
      { text: 'Mediano', value: 'B' },
      { text: 'Mediano-grande', value: 'C' },
      { text: 'Grande', value: 'D' }
    ]
  },
  {
    id: 10,
    icon: 'ri-money-euro-circle-line',
    question: 'En gastos (veterinario + alimentación)…',
    options: [
      { text: 'Prefiero costes bajos', value: 'A' },
      { text: 'Costes moderados', value: 'B' },
      { text: 'Estoy preparado para invertir', value: 'C' },
      { text: 'No es limitación', value: 'D' }
    ]
  },
  {
    id: 11,
    icon: 'ri-heart-line',
    question: 'Busco un perro principalmente…',
    options: [
      { text: 'Tranquilo y de compañía', value: 'A' },
      { text: 'Familiar y adaptable', value: 'B' },
      { text: 'Activo y aventurero', value: 'C' },
      { text: 'Protector / trabajo', value: 'D' }
    ]
  },
  {
    id: 12,
    icon: 'ri-star-line',
    question: 'Tu experiencia con perros es…',
    options: [
      { text: 'Primera vez', value: 'A' },
      { text: 'He tenido perro (básico)', value: 'B' },
      { text: 'Tengo buena experiencia', value: 'C' },
      { text: 'Alta experiencia (entreno y manejo)', value: 'D' }
    ]
  }
];

export const results: Record<string, Result> = {
  A: {
    title: 'Urbano & Tranquilo',
    description: 'Te va mejor un perro de energía moderada, fácil de manejar en piso y con rutinas sencillas.',
    breeds: [
      {
        name: 'Bichón Maltés',
        image: 'https://public.readdy.ai/ai/img_res/81426c795d0fb1ce50304b3c9a15a1ff.jpg',
        description: 'Pequeño, cariñoso y muy apegado a su familia. Ideal para pisos por su tamaño y bajo nivel de ejercicio requerido.'
      },
      {
        name: 'Shih Tzu',
        image: 'https://readdy.ai/api/search-image?query=Shih%20Tzu%20dog%20portrait%20long%20hair%20small%20breed%20adorable%20face%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting%20high%20quality&width=400&height=300&seq=shihtzu1&orientation=landscape',
        description: 'Compañero tranquilo y afectuoso. Requiere cepillado regular pero tiene necesidades de ejercicio moderadas.'
      },
      {
        name: 'Caniche Mini/Toy',
        image: 'https://readdy.ai/api/search-image?query=Miniature%20Poodle%20dog%20portrait%20curly%20coat%20elegant%20small%20breed%20intelligent%20expression%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=poodle1&orientation=landscape',
        description: 'Muy inteligente y fácil de entrenar. Hipoalergénico y adaptable a espacios pequeños.'
      },
      {
        name: 'Pug',
        image: 'https://readdy.ai/api/search-image?query=Pug%20dog%20portrait%20fawn%20color%20wrinkled%20face%20cute%20expression%20small%20breed%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=pug1&orientation=landscape',
        description: 'Sociable y juguetón. Perfecto para vida en apartamento, aunque hay que cuidar su respiración.'
      },
      {
        name: 'Bulldog Francés',
        image: 'https://readdy.ai/api/search-image?query=French%20Bulldog%20dog%20portrait%20bat%20ears%20muscular%20compact%20body%20adorable%20expression%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=frenchie1&orientation=landscape',
        description: 'Calmado y cariñoso. No necesita mucho ejercicio y se adapta muy bien a la vida urbana.'
      }
    ],
    advice: 'En piso: trabaja rutina, soledad y ladrido. Juegos de olfato en casa ayudan mucho.'
  },
  B: {
    title: 'Familiar & Equilibrado',
    description: 'Quieres un perro adaptable, sociable y estable. Ideal para primer perro si eres constante.',
    breeds: [
      {
        name: 'Golden Retriever',
        image: 'https://readdy.ai/api/search-image?query=Golden%20Retriever%20dog%20portrait%20golden%20coat%20friendly%20expression%20beautiful%20medium%20large%20breed%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=golden1&orientation=landscape',
        description: 'El perro familiar por excelencia. Amigable, paciente con niños y muy fácil de entrenar.'
      },
      {
        name: 'Labrador Retriever',
        image: 'https://readdy.ai/api/search-image?query=Labrador%20Retriever%20dog%20portrait%20yellow%20lab%20friendly%20face%20medium%20large%20breed%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=labrador1&orientation=landscape',
        description: 'Versátil y sociable. Excelente con familias, muy adaptable y de temperamento equilibrado.'
      },
      {
        name: 'Cocker Spaniel',
        image: 'https://readdy.ai/api/search-image?query=Cocker%20Spaniel%20dog%20portrait%20long%20ears%20beautiful%20coat%20gentle%20expression%20medium%20breed%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=cocker1&orientation=landscape',
        description: 'Alegre y cariñoso. Tamaño mediano ideal, muy sociable y bueno con niños.'
      },
      {
        name: 'Mestizo Mediano',
        image: 'https://readdy.ai/api/search-image?query=Mixed%20breed%20dog%20portrait%20medium%20size%20friendly%20expression%20healthy%20looking%20adoptable%20dog%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=mestizo1&orientation=landscape',
        description: 'Los mestizos suelen tener mejor salud genética. Cada uno es único y especial.'
      },
      {
        name: 'Cavalier King Charles',
        image: 'https://readdy.ai/api/search-image?query=Cavalier%20King%20Charles%20Spaniel%20dog%20portrait%20elegant%20long%20ears%20gentle%20expression%20small%20breed%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=cavalier1&orientation=landscape',
        description: 'Dulce y adaptable. Perfecto compañero de sofá pero también disfruta paseos tranquilos.'
      }
    ],
    advice: 'Perfectos en ciudad si tienen paseos mentales y educación básica desde el día 1.'
  },
  C: {
    title: 'Activo & Aventurero',
    description: 'Necesitas un perro con energía y mente. Este perfil requiere actividad diaria real y retos.',
    breeds: [
      {
        name: 'Border Collie',
        image: 'https://readdy.ai/api/search-image?query=Border%20Collie%20dog%20portrait%20black%20white%20coat%20intelligent%20eyes%20athletic%20herding%20breed%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=border1&orientation=landscape',
        description: 'El más inteligente de todos. Necesita estimulación mental constante y mucho ejercicio.'
      },
      {
        name: 'Pastor Australiano',
        image: 'https://readdy.ai/api/search-image?query=Australian%20Shepherd%20dog%20portrait%20merle%20coat%20beautiful%20eyes%20athletic%20herding%20breed%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=aussie1&orientation=landscape',
        description: 'Enérgico y leal. Excelente para deportes caninos y actividades al aire libre.'
      },
      {
        name: 'Braco Alemán',
        image: 'https://readdy.ai/api/search-image?query=German%20Shorthaired%20Pointer%20dog%20portrait%20athletic%20hunting%20breed%20elegant%20spotted%20coat%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=braco1&orientation=landscape',
        description: 'Atlético y versátil. Ideal para personas muy activas que disfrutan del campo.'
      },
      {
        name: 'Husky Siberiano',
        image: 'https://readdy.ai/api/search-image?query=Siberian%20Husky%20dog%20portrait%20blue%20eyes%20wolf%20like%20appearance%20beautiful%20thick%20coat%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=husky1&orientation=landscape',
        description: 'Independiente y resistente. Requiere mucho ejercicio y tiene instinto de escape.'
      },
      {
        name: 'Podenco',
        image: 'https://readdy.ai/api/search-image?query=Podenco%20dog%20portrait%20elegant%20slender%20body%20large%20ears%20Spanish%20hunting%20breed%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=podenco1&orientation=landscape',
        description: 'Ágil y cariñoso. Raza española que necesita espacio para correr y explorar.'
      }
    ],
    advice: 'No es solo ejercicio físico: también olfato y obediencia. Sin esto, se frustran.'
  },
  D: {
    title: 'Alta Demanda / Guardián',
    description: 'Perfil exigente: requiere constancia, experiencia y estructura.',
    breeds: [
      {
        name: 'Pastor Alemán',
        image: 'https://readdy.ai/api/search-image?query=German%20Shepherd%20dog%20portrait%20noble%20expression%20black%20tan%20coat%20large%20breed%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=gsd1&orientation=landscape',
        description: 'Leal y protector. Muy inteligente, necesita trabajo mental y físico constante.'
      },
      {
        name: 'Pastor Belga Malinois',
        image: 'https://readdy.ai/api/search-image?query=Belgian%20Malinois%20dog%20portrait%20athletic%20alert%20expression%20fawn%20coat%20working%20breed%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=malinois1&orientation=landscape',
        description: 'Extremadamente activo y trabajador. Solo para personas con experiencia avanzada.'
      },
      {
        name: 'Dóberman',
        image: 'https://readdy.ai/api/search-image?query=Doberman%20Pinscher%20dog%20portrait%20elegant%20muscular%20black%20tan%20coat%20noble%20expression%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=doberman1&orientation=landscape',
        description: 'Elegante y protector. Muy leal a su familia, requiere socialización temprana.'
      },
      {
        name: 'Rottweiler',
        image: 'https://readdy.ai/api/search-image?query=Rottweiler%20dog%20portrait%20powerful%20muscular%20black%20tan%20markings%20confident%20expression%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=rottweiler1&orientation=landscape',
        description: 'Fuerte y confiado. Excelente guardián familiar con el entrenamiento adecuado.'
      },
      {
        name: 'Mastín Español',
        image: 'https://readdy.ai/api/search-image?query=Spanish%20Mastiff%20dog%20portrait%20giant%20breed%20noble%20expression%20thick%20coat%20guardian%20breed%20professional%20pet%20photography%20clean%20neutral%20background%20studio%20lighting&width=400&height=300&seq=mastin1&orientation=landscape',
        description: 'Gigante tranquilo pero protector. Ideal para fincas y espacios amplios.'
      }
    ],
    advice: 'Revisa normativa autonómica/municipal si aplica PPP. Socialización y educación profesional.'
  }
};
